import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [interests, setInterests] = useState([]);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const interestOptions = [
    { id: 'market-analysis', label: 'Market Analysis', icon: 'TrendingUp' },
    { id: 'transformation', label: 'Digital Transformation', icon: 'Zap' },
    { id: 'innovation', label: 'Innovation Frameworks', icon: 'Lightbulb' },
    { id: 'industry-spotlights', label: 'Industry Spotlights', icon: 'Target' }
  ];

  const handleInterestChange = (interestId, checked) => {
    if (checked) {
      setInterests([...interests, interestId]);
    } else {
      setInterests(interests.filter(id => id !== interestId));
    }
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  if (isSubscribed) {
    return (
      <div className="bg-gradient-to-r from-green-500 to-blue-600 rounded-xl p-8 text-center">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} className="text-white" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">
          Welcome to Our Community!
        </h3>
        <p className="text-white">
          You'll receive personalized insights based on your interests.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-4 sm:p-6 lg:p-8 overflow-hidden">
      <div className="text-center mb-4 sm:mb-6">
        <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-2">
          Stay Ahead of the Curve
        </h3>
        <p className="text-sm sm:text-base text-white">
          Get personalized insights delivered to your inbox weekly
        </p>
      </div>

      <form onSubmit={handleSubscribe} className="space-y-4 sm:space-y-6">
        <Input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-white/95 border-gray-300 text-slate-900 placeholder-slate-600 focus:bg-white w-full"
          required
        />

        <div>
          <p className="text-white font-medium mb-3 text-sm sm:text-base">
            Customize your content preferences:
          </p>
          <div className="grid grid-cols-1 gap-2 sm:gap-3">
            {interestOptions.map((option) => (
              <Checkbox
                key={option.id}
                label={
                  <div className="flex items-center space-x-2 min-w-0">
                    <Icon name={option.icon} size={14} className="text-white flex-shrink-0" />
                    <span className="text-white text-xs sm:text-sm truncate">{option.label}</span>
                  </div>
                }
                checked={interests.includes(option.id)}
                onChange={(e) => handleInterestChange(option.id, e.target.checked)}
                className="text-white min-w-0"
              />
            ))}
          </div>
        </div>

        <Button
          type="submit"
          variant="default"
          fullWidth
          className="bg-white text-blue-600 hover:bg-gray-100 font-semibold text-sm sm:text-base"
          iconName="Mail"
          iconPosition="left"
        >
          Subscribe to Insights
        </Button>
      </form>

      <p className="text-xs text-white text-center mt-3 sm:mt-4 leading-relaxed">
        No spam, unsubscribe anytime. We respect your privacy.
      </p>
    </div>
  );
};

export default NewsletterSubscription;